/**
 * Constants for Segment analytics events
 * Contains common properties that should be included in all segment events
 */

const SEGMENT_CONSTANTS = {
  IMPLEMENTATION_SOURCE: "segment_native",
} as const;

/**
 * Common properties that should be included in all segment events
 */
export const SEGMENT_COMMON_PROPERTIES: Record<string, string> = {
  implementation_source: SEGMENT_CONSTANTS.IMPLEMENTATION_SOURCE,
};

/**
 * Generic Event Names
 */
export const TRACKING_EVENTS = {
  PAGE_VIEW: "Page View",
  FORM_SUBMISSION: "Form Submission",
  ONETRUST_GROUPS_UPDATED: "OneTrustGroupsUpdated",
  ADAPTIVE_LOADING_MODE_CHANGED: "Adaptive Loading Mode Changed",
  ADAPTIVE_LOADING_LCP_RESOLVED: "Adaptive Loading LCP Resolved",
} as const;
